import axiosPost from '../axiosPost';

export const tiposDeDeviceGet = async (arg) => {
    const { params } = arg;
    const body = {
        "service": "TipoDeviceGet",
        "params": params ? params : {}
    }
    
    try {
        const result = await axiosPost('Y', body, arg)
        return result.data.result
    } catch (err) {
        console.log(err)
    }
};